(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maibec-minimum-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__maibecQuotePopup) return;
    window.__maibecQuotePopup = true;

    const getDialog = () => {
      let dialog = document.getElementById('maibec-quote-dialog');
      if (dialog) return dialog;
      dialog = document.createElement('dialog');
      dialog.id = 'maibec-quote-dialog';
      dialog.className = 'maibec-quote-dialog';
      dialog.setAttribute('aria-label', 'Request shipping cost');
      dialog.innerHTML =
        '<button type="button" class="maibec-quote-dialog__close" aria-label="Close">&times;</button>' +
        '<iframe class="maibec-quote-dialog__frame" title="Material Shipping Request"></iframe>';
      dialog.querySelector('.maibec-quote-dialog__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        dialog.querySelector('iframe').removeAttribute('src');
      });
      document.body.appendChild(dialog);
      return dialog;
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-maibec-quote]');
      if (!link || typeof HTMLDialogElement === 'undefined') return;
      event.preventDefault();
      const dialog = getDialog();
      dialog.querySelector('iframe').src = link.href;
      dialog.showModal();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
